import { useEffect, useRef } from 'react';
import { useUIStore } from '@/stores/uiStore';

export const useAutoRefresh = (callback: () => void | Promise<void>, dependencies: any[] = []) => {
  const { autoRefreshEnabled, autoRefreshInterval } = useUIStore();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!autoRefreshEnabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Execute immediately on mount
    callback();

    // Set up interval
    intervalRef.current = setInterval(() => {
      callback();
    }, autoRefreshInterval * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [autoRefreshEnabled, autoRefreshInterval, ...dependencies]);

  return {
    isEnabled: autoRefreshEnabled,
    interval: autoRefreshInterval,
  };
};